export default __webpack_public_path__ + "static/media/cert-E-commerce-consumer.dddd627c.jpg";